<template>
  <div class="">
    <!-- 信用流水 -->
    <el-card class="box-card">
      <div class="search-form" style="text-align: left">
        <el-form ref="searchForm" :inline="true" size="small" :model="searchForm" label-width="80px" label-position="left"
          class="demo-form-inline">
          <el-form-item :label="$t('finance.credit.changeTime')">
            <el-date-picker
              style="width:320px;"
              v-model="searchForm.createtime"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :range-separator="$t('finance.credit.to')"
              :start-placeholder="$t('finance.credit.startDate')"
              :end-placeholder="$t('finance.credit.endDate')">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('finance.credit.changeMethod')">
            <el-select v-model="searchForm.type" :placeholder="$t('finance.credit.placeholder.selectChangeMethod')">
              <el-option :label="$t('finance.credit.increase')" :value="0"></el-option>
              <el-option :label="$t('finance.credit.deduction')" :value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button icon="el-icon-search" type="primary" size="small" @click="handleSearch">{{ $t('finance.credit.button.query') }}</el-button>
            <el-button icon="el-icon-refresh-right" type="primary" size="small" @click="resetSearch">{{ $t('finance.credit.button.reset') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="" style="margin-bottom: 15px;text-align:left">
        <el-button type="primary" icon="el-icon-download" size="small" @click="handleExport">{{ $t('finance.credit.button.export') }}</el-button>
      </div>
      <el-table :data="dataList" border size="small" height="600">
        <el-table-column type="index" :index="indexMethod" :label="$t('finance.credit.serialNumber')" width="60"></el-table-column>
        <el-table-column prop="createtime" :label="$t('finance.credit.changeTime')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="num" :label="$t('finance.credit.changeAmount')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="before_num" :label="$t('finance.credit.amountBeforeChange')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="later_num" :label="$t('finance.credit.amountAfterChange')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="type" :label="$t('finance.credit.changeMethod')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="title" :label="$t('finance.credit.changeReason')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" :label="$t('finance.credit.deductionNote')" show-overflow-tooltip></el-table-column>
      </el-table>
      <div class="pagization-box">
        <CustomPagization
          :background="true"
          :currentPage="current"
          :total="total"
          :pageSize="size"
          @current-change="currentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { creditList, creditExport } from '@/api/finance'
import { downloadBase64AsExcel } from "@/common/common.js"
export default {
  data() {
    return {
      searchForm: {},
      current: 1,
      size: 20,
      total: 1,
      dataList: [],
    };
  },
  mounted(){
    this.getCreditList()
  },
  methods: {
    // 导出数据
    handleExport(){
      creditExport({
        user_code:JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
        ...this.searchForm
      }).then(res => {
        downloadBase64AsExcel(res.data.file,res.data.name)
      })
    },
    // 获取列表
    getCreditList(){
      let queryForm = {}
      if(this.searchForm.createtime){
        queryForm = {
          ...this.searchForm,
          createtime: this.searchForm.createtime.join("/")
        }
      }else{
        queryForm = {
          ...this.searchForm
        }
      }
      creditList({
        user_code:JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
        page: this.current,
        // limit: this.size,
        ...queryForm
      }).then(res => {
        if(res.code == 1){
          this.dataList = []
          this.dataList = res.data.list
          this.total = res.data.total
        }
      })
    },
    // table首列序号
    indexMethod(index) {
      return (this.current - 1) * this.size + index + 1;
    },
    // 页数变化
    currentChange(current) {
      this.current = current;
      this.getCreditList();
    },
    // 重置筛选
    resetSearch() {
      this.$refs["searchForm"].resetFields();
      this.searchForm = {}
      this.value1 = []
      this.current = 1;
      this.total = 1;
      this.dataList = [];
      this.handleSearch();
    },
    // 去筛选
    handleSearch() {
      this.current = 1;
      this.total = 1;
      this.dataList = [];
      this.getCreditList();
    },
  },
};
</script>
<style lang="scss" scoped>
.pagization-box {
  overflow: hidden;
  margin-top: 10px;

  .el-pagination {
    float: right;
  }
}
/deep/ {
  .el-table {
    thead {
      color: #fff;
      font-weight: 500;
      background: #F5F7FA;
      color: #606266;
      & th {
        background-color: transparent;
      }
      & tr {
        background-color: transparent;
      }
    }
  }
}
</style>